import { render, staticRenderFns } from "./UserInactivityWarningCard.vue?vue&type=template&id=1d22472c&scoped=true&"
import script from "./UserInactivityWarningCard.vue?vue&type=script&lang=js&"
export * from "./UserInactivityWarningCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d22472c",
  null
  
)

export default component.exports